import React from 'react';

import EcAccountForm from '@components/shared/ec_accounts/EcAccountForm';
import { useOperatorData } from '@contexts/operator/OperatorDataContext';
import useRecordMerchantSync from '@hooks/operator/useRecordMerchantSync';

import { ecAccountService } from '@services/operator/ecAccountService';
import { salesChannelService } from '@services/operator/salesChannelService';
import { shippingTypeService } from '@services/operator/shippingTypeService';

interface ReferenceOption {
  id: string;
  name?: string;
  [key: string]: unknown;
}

interface MerchantShippingTypeRow {
  id: string;
  name?: string;
  code?: string;
  [key: string]: unknown;
}

// 編輯模式：record 自帶 merchant_id；useRecordMerchantSync 會把 OperatorDataContext.currentMerchant
// 切到該 record 所屬 merchant，避免 multi-merchant operator 把 header 選擇的 B merchant 之
// sales_channel / shipping_type 寫進 A 的 record。merchantDataLoading 為 true 時擋住 form
// 渲染，等 context 切完才放下拉資料。
//
// 注意：本頁只處理編輯（route 為 /ec_accounts/:id/edit）。新增走 New.tsx → /ec_accounts/new，
// 因此不再需要 isCreate 分支。
const OperatorEcAccountEdit: React.FC = () => {
  const {
    merchantSalesChannels,
    merchantShippingTypes,
  } = useOperatorData() as {
    merchantSalesChannels: ReferenceOption[];
    merchantShippingTypes: MerchantShippingTypeRow[];
  };
  const { handleRecordLoaded, merchantDataLoading } = useRecordMerchantSync();

  return (
    <EcAccountForm
      ecAccountService={ecAccountService}
      salesChannelService={salesChannelService}
      shippingTypeService={shippingTypeService}
      role="operator"
      mode="edit"
      salesChannels={merchantSalesChannels ?? []}
      shippingTypes={(merchantShippingTypes ?? []) as ReferenceOption[]}
      onEcAccountLoaded={handleRecordLoaded}
      merchantDataLoading={merchantDataLoading}
    />
  );
};

export default OperatorEcAccountEdit;
